import { render } from "./NewOrderDropoff.vue?vue&type=template&id=06456298&ts=true"
import script from "./NewOrderDropoff.ts?vue&type=script&lang=ts"
export * from "./NewOrderDropoff.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__